// extracted by mini-css-extract-plugin
export default {"addReference":"AddReference_addReference__kK8or"};